import { render } from "./ZhaiTwoTuttonsPC.vue?vue&type=template&id=bf2aa6f8&scoped=true"
import script from "./ZhaiTwoTuttonsPC.vue?vue&type=script&lang=js"
export * from "./ZhaiTwoTuttonsPC.vue?vue&type=script&lang=js"

import "./ZhaiTwoTuttonsPC.vue?vue&type=style&index=0&id=bf2aa6f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2aa6f8"]])

export default __exports__